import { QUICK_VUE_IMAGES } from '../quickVueConfig';

let cardNumberCounter = 1;

const HOUSE_FEATURES_PAGE_TITLE = `Does the house have any of these features?`;
const OUTBUILDINGS_TITLE = 'Outbuildings';
const SWIMMING_POOL_TITLE = 'Swimming Pool';
const TRAMPOLINE_TITLE = 'Trampoline';
const WOOD_STOVE_TITLE = 'Wood Stove';
const FINISHED_BASEMENT_TITLE = 'Finished Basement';

export const remoteQuestions = [
  {
    cardNumber: cardNumberCounter++,
    allowResume: false,
    type: 'title',
    answerValue: null,
    hideDevButton: true,
    hideActions: false,
    hideBackButton: true,
    navLabel: `Let's get started!`,
    questionLabel: (step, stepIndex, selfInspectInfo) =>
      `Hi${
        !!selfInspectInfo?.insuredName ? ` ${selfInspectInfo?.insuredName}` : ''
      }, I'm with JMI Reports representing ${selfInspectInfo.clientName} and ${
        selfInspectInfo.agencyName
      }. We need to get photos of this property to verify your policy.  The address on file is ${
        selfInspectInfo.clientAddress
      }. We will only be taking exterior photos.`,
    questionImage: `../../assets/images/bluesky-vue-logo-only.png`,
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: false,
    type: 'idbadge',
    answerValue: null,
    hideDevButton: true,
    hideActions: false,
    navLabel: `Continue`,
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: false,
    type: 'yesno',
    questionLabel: 'Homeowner available for quick interview?',
    questionId: 1007,
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: false,
    type: 'multi-input',
    title: `Let's confirm a few details`,
    continueButtonText: 'Looks good!',
    navLabel: `Keep going!`,
    navLabelDisabled: `Details please!`,
    showIf: (steps, question, index) => {
      return steps?.find(q => q.questionId === 1007)?.answerValue;
    },
    questions: [
      {
        type: 'select',
        questionLabel: 'Do you know the age of the roof?',
        questionId: 2434,
        options: [
          {
            label: '0 - 4 years',
            value: 11061,
          },
          {
            label: '5 - 10 years',
            value: 11062,
          },
          {
            label: '11 - 14 years',
            value: 11063,
          },
          {
            label: '15+ years',
            value: 11064,
          },
        ],
      },
      {
        type: 'select',
        questionLabel: 'What type of foundation does the home have?',
        questionId: 290,
        options: [
          {
            label: 'Unfinished Basement',
            value: 49,
          },
          {
            label: 'Finished Basement',
            value: 50,
          },
          {
            label: 'Crawl Space',
            value: 71,
          },
          {
            label: 'Slab',
            value: 166,
          } /*,
          {
            label: 'Unknown' //,
            //value: null
          }*/,
        ],
      },
      {
        type: 'select',
        questionLabel: 'Do you have a wood stove or pellet stove?',
        questionId: 9920,
        options: [
          {
            label: 'Yes',
            value: 3,
          },
          {
            label: 'No',
            value: 4,
          },
        ],
      },
      {
        type: 'select',
        questionLabel: 'Do you have any dogs?',
        questionId: 9922,
        options: [
          {
            label: 'Yes',
            value: 3,
          },
          {
            label: 'No',
            value: 4,
          },
        ],
      },
    ],
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    type: 'title',
    questionImage: QUICK_VUE_IMAGES.HOUSE_FRONT,
    //questionLabel: 'Time to get some fresh air!',
    questionLabel: 'We need a few pictures of the outside of the house.',
    questionLabel2: 'You can take multiple photos on each page. Please take photos during daylight hours.',
    // questionLabel3: 'Please take photos during daylight hours.',
    navLabel: `Let's get started!`,
  },

  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 352,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_FRONT_LEFT,
    questionLabel: `Let's get some corner pictures that show the FRONT and LEFT SIDE of the house`,
    answerValue: null,
    shortLabel: 'Front & left side',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 7110,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_ROOF_CLOSEUP,
    questionLabel: `Let's get some zoomed in closeups of the roof`,
    //questionLabel2: `(Zoomed in, no need to get a ladder!)`,
    answerValue: null,
    shortLabel: 'Roof',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 354,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_FRONT_RIGHT,
    questionLabel: `Let's get some corner pictures that show the FRONT and RIGHT SIDE of the house`,
    answerValue: null,
    shortLabel: 'Font & right side',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 358,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_REAR_RIGHT,
    questionLabel: `Let's get some corner pictures that show the BACK and RIGHT SIDE of the house`,
    answerValue: null,
    shortLabel: 'Back & right side',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 357,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_REAR_LEFT,
    questionLabel: `Let's get some corner pictures that show the BACK and LEFT SIDE of the house`,
    answerValue: null,
    shortLabel: 'Back & left side',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 9958,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.BACKYARD,
    questionLabel: `Take some photos of the backyard from the rear of the house`,
    answerValue: null,
    shortLabel: 'Backyard',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    type: 'image-checkboxes',
    title: HOUSE_FEATURES_PAGE_TITLE,
    continueButtonText: 'Keep going!',
    questions: [
      {
        questionId: 9921,
        type: 'checkbox',
        questionLabel: OUTBUILDINGS_TITLE,
        questionImage: QUICK_VUE_IMAGES.EXPOSURE_OUTBUILDING,
        answerValue: false,
      },
      {
        questionId: 350,
        type: 'checkbox',
        questionLabel: SWIMMING_POOL_TITLE,
        questionImage: QUICK_VUE_IMAGES.EXPOSURE_POOL,
        answerValue: false,
      },
      {
        questionId: 363,
        type: 'checkbox',
        questionLabel: TRAMPOLINE_TITLE,
        questionImage: QUICK_VUE_IMAGES.EXPOSURE_TRAMPOLINE,
        answerValue: false,
      },
    ],
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 7719,
    type: 'take-picture',
    multiple: true,
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === OUTBUILDINGS_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.EXPOSURE_OUTBUILDING,
    questionLabel: `You indicated that the house has outbuildings, let's get some pictures of those.`,
    answerValue: null,
    shortLabel: 'Outbuildings',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 9927,
    type: 'take-picture',
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === SWIMMING_POOL_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.EXPOSURE_POOL,
    questionLabel: `You indicated that the house has a swimming pool, let's get a picture of that.`,
    answerValue: null,
    shortLabel: 'Swimming Pool',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 9928,
    type: 'take-picture',
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === TRAMPOLINE_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.EXPOSURE_TRAMPOLINE,
    questionLabel: `You indicated that the house has a trampoline, let's get a picture of that.`,
    answerValue: null,
    shortLabel: 'Trampoline',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 351,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.ADDRESS,
    questionLabel: `Lastly, to verify location, we need a picture of the house number/address if visible`,
    answerValue: null,
    shortLabel: 'Address Verification',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: false,
    type: 'title',
    hideActions: false,
    answerValue: null,
    hideDevButton: true,
    hideBackButton: false,
    handleUnfinishedUploads: true,
    questionImage: '', //QUICK_VUE_IMAGES.CLIENT_LOGO,
    //questionLabel: 'Thank you for choosing Cincinnati Insurance and The Langford Agency to protect your home and for taking your time to complete this survey.',
    //questionLabel2: 'You can now close this window',
    navLabel: `Finish Survey!`,
    //
    questionLabel: (step, stepIndex, selfInspectInfo) => `Please press "Finish Survey" to submit your response.`,
    questionImage: (step, stepIndex, selfInspectInfo) =>
      `https://jmistorage.blob.core.windows.net/clientid-${selfInspectInfo.clientId}/logo.jpg`,
  },

  {
    cardNumber: cardNumberCounter++,
    allowResume: false,
    type: 'title',
    hideActions: true,
    answerValue: null,
    hideDevButton: true,
    hideBackButton: true,
    //questionImage: QUICK_VUE_IMAGES.CLIENT_LOGO,
    questionLabel: 'Your survey has been received, you can now close this window.',
    //questionLabel2: 'You can now close this window',
    questionImage: (step, stepIndex, selfInspectInfo) =>
      `https://jmistorage.blob.core.windows.net/clientid-${selfInspectInfo.clientId}/logo.jpg`,
  },
];

export const selfInspectError = [
  {
    cardNumber: 1,
    type: 'title',
    answerValue: null,
    hideDevButton: true,
    hideActions: true,
    navLabel: ``,
    questionLabel: `We can't seem to find your survey, it may have already been submitted or the link has expired. If you have questions, please email service@jmireports.com or call us at <nobr><a href="tel:+14406288304">(440) 628-8304</a></nobr>.`,
    questionLabel2: 'error',
    questionImage: QUICK_VUE_IMAGES.BLUESKY,
    //questionLabel: `Hi there! ${selfInspectIntro.clientName} and ${selfInspectIntro.agencyName} need your help in finalizing your policy by providing us with a few additional details and pictures of your home.`,
    questionImage: (step, stepIndex, selfInspectInfo) =>
      `https://jmistorage.blob.core.windows.net/clientid-${selfInspectInfo.clientId}/logo.jpg`,
  },
];
